import { Tooltip } from '@airbus/components-react';
import { GridColDef, GridColumnHeaderTitle } from '@mui/x-data-grid-premium';

export const withAirbusTooltip = (cols: GridColDef[]): GridColDef[] =>
  cols.map((col) => {
    return {
      ...col,
      renderHeader: (params) => {
        const isEditable = params?.colDef?.editable ?? false;
        const currentHeader = (params?.colDef?.headerName ?? '').toString();
        const isMandatory = currentHeader.trim().endsWith('*');
        const baseHeader =
          isMandatory && currentHeader
            ? currentHeader.replace(/\*$/, '').trim()
            : currentHeader ?? '';
        const headerLabel = isMandatory && isEditable ? `${baseHeader} *` : baseHeader;

        return (
          <Tooltip label={headerLabel}>
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              <GridColumnHeaderTitle
                label={headerLabel}
                columnWidth={params.colDef.computedWidth ?? col.width ?? 100}
              />
            </span>
          </Tooltip>
        );
      },
    };
  });
